import { render, staticRenderFns } from "./DollarIcon.vue?vue&type=template&id=23d17c84&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23d17c84')) {
      api.createRecord('23d17c84', component.options)
    } else {
      api.reload('23d17c84', component.options)
    }
    module.hot.accept("./DollarIcon.vue?vue&type=template&id=23d17c84&", function () {
      api.rerender('23d17c84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/DollarIcon.vue"
export default component.exports